import Body from './processes/body/body';
import Face from './processes/body/head/face/face';

class Mediaprocessing {
  async run(target) {
    const { id, role } = target;
    await new Body(id, role).run();
    await new Face(role).run();
  }
}

export default Mediaprocessing;